import initialState from '../initialState.js';
import {
    GET_COVERAGE
} from '../../actions/types/coverage';

export default (state = initialState.coverage, action) => {
    switch (action.type) {
        case GET_COVERAGE: {
            return {
                ...state,
                data: action.coverage
            };
        }

        default:
            return state;
    }
};